import React from 'react';
import PropTypes from 'prop-types';

const OrderDetailsCard = ({ order_details, order_date_time, customer_name, customer_phone, customer_address }) => {
  return (
    <div className="se-w-fill se-pb-5">
      <h2 className="se-text-[16px] se-text-left se-font-medium se-mb-2 se-pt-5">Order Details</h2>
      <p className="se-text-2xl se-text-left se-font-medium se-mb-4">{order_details}</p>
      <hr className="se-mb-4" />

      <div className="se-mb-3 se-py-2 se-border-b se-border-[#8888881A]">
        <h3 className="se-text-sm se-text-left se-font-medium">Order Date Time</h3>
        <p className="se-text-gray-500 se-text-left">{order_date_time}</p>
      </div>

      <div className="se-mb-3 se-py-2 se-border-b se-border-[#8888881A]">
        <h3 className="se-text-sm se-text-left se-font-medium">Customer Name</h3>
        <p className="se-text-gray-600 se-text-left">{customer_name}</p>
      </div>

      <div className="se-mb-3 se-py-2 se-border-b se-border-[#8888881A]">
        <h3 className="se-text-sm se-font-medium se-text-left">Customer Phone</h3>
        <p className="se-text-gray-600 se-text-left">{customer_phone || '-'}</p>
      </div>

      <div>
        <h3 className="se-text-sm se-font-medium se-text-left">Customer Address</h3>
        <p className="se-text-gray-600 se-text-left ">{customer_address}</p>
      </div>
    </div>
  );
};

OrderDetailsCard.propTypes = {
  order_details: PropTypes.string.isRequired,     // Order ID or details
  order_date_time: PropTypes.string.isRequired,   // Date and time of the order
  // customer_name: PropTypes.string.isRequired,     // Customer's name
  // customer_phone: PropTypes.string.isRequired,    // Customer's phone number
  customer_address: PropTypes.string.isRequired,  // Customer's address
};

export default OrderDetailsCard;